import { render, staticRenderFns } from "./UploadsTooltip.vue?vue&type=template&id=070bf146&"
import script from "./UploadsTooltip.vue?vue&type=script&lang=js&"
export * from "./UploadsTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports